import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { sameType } from '../../../utils/react';

/**
 * Da una lista di nodi separa quelli di tipo DropdownList.
 * @param {PropTypes.node | PropTypes.node[] | undefined } children
 * @returns {PropTypes.node[]} il primo elemento è il nodo DropdownList, il secondo la lista di tutti gli altri nodi.
 */
function extractDropDownList(children) {
  let dropDownItems;
  const others = [];
  React.Children.forEach(children, (child) => {
    if (sameType(child, DropdownList)) {
      dropDownItems = child;
    } else {
      others.push(child);
    }
  });
  return [dropDownItems, others];
}

/**
Lista di elementi visualizzati in dropdown.
 */
const DropdownList = ({ className, blockClassName, children }) => (
  children && (
    <ul
      className={cns(blockClassName, className)}
      role="menu"
    >
      {children}
    </ul>
  )
);

DropdownList.extractDropDownList = extractDropDownList;

DropdownList.propTypes = {
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,

  /** Classi css relative al Block (vedi BEM). Ad uso INTERNO. */
  blockClassName: PropTypes.string,

  /** Children del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

DropdownList.defaultProps = {
  children: undefined,
  blockClassName: 'v2-dropdown-list',
  className: undefined,
};

export default DropdownList;
